import Container from '../../components/menu/Container';
import { useTranslation } from "react-i18next";
import CampanhaList from './CampanhaList';
import React, { useRef, useState } from 'react';
import { Button } from 'primereact/button';
import { Toolbar } from 'primereact/toolbar';
import CampanhaCadastrar from './CampanhaCadastrar';
import VoucherManager from './VoucherManager';
import { Messages } from 'primereact/messages';
import postCampanha from "../../service/postCampanha";
import putCampanha from '../../service/putCampanha';

export default function CampanhaPage() {
  const { t } = useTranslation();
  const msgs = useRef<Messages>(null);
  const [campanha, setCampanha] = useState<any | null>(null);
  const [voucherCampanha, setVoucherCampanha] = useState<any | null>(null);
  const labelButton = t('cadastrar');

  const showResultado = (data: string) => {
    if (data && data.includes('Erro')) {
      msgs.current?.clear();
      msgs.current?.show([{ sticky: false, life: 10000, severity: 'error', summary: 'Erro', detail: data, closable: false }]);
    } else {
      setCampanha(null);
      msgs.current?.clear();
      msgs.current?.show([{ sticky: false, life: 10000, severity: 'success', summary: 'Sucesso', detail: data, closable: false }]);
    }
  }

  const saveCampanha = (campanha: any) => {
    if (campanha.id) {
      putCampanha(campanha).then(showResultado);
    } else {
      postCampanha(campanha).then(showResultado);
    }
  }

  const startContent = (
    <React.Fragment>
      <Button label={labelButton} icon="pi pi-plus" style={{ backgroundColor: '#183462' }} onClick={() => { setCampanha({}) }} />
    </React.Fragment>
  );

  return (
    <Container>
      <div className="row">
        <div className="col-lg-12 mb-3">
          <div className="d-sm-flex align-items-center justify-content-between mb-4">
            <h1 className="h3 mb-0 text-gray"><i className="pi pi-gift" style={{ fontSize: '2.0rem' }}></i> {t('campanhas')}</h1>
          </div>
        </div>
      </div>
      <div className="card">
        <Messages ref={msgs} />
        {!campanha && !voucherCampanha && (
          <>
            <Toolbar start={startContent} />
            <br></br>
            <br></br>
            <CampanhaList
              onEdit={(campanha: any) => { setCampanha(campanha); }}
              onVouchers={(campanha: any) => { setVoucherCampanha(campanha); }}
            ></CampanhaList>
          </>
        )}
        {campanha && (
          <CampanhaCadastrar campanha={campanha} onSave={saveCampanha} onClose={() => { setCampanha(null) }} msgs={msgs}></CampanhaCadastrar>
        )}
        {voucherCampanha && (
          <VoucherManager campanha={voucherCampanha} onClose={() => { setVoucherCampanha(null) }} msgs={msgs}></VoucherManager>
        )}
      </div>
    </Container>
  )
}
